<!-- 普通用户 -->
<template>
  <div class="app-container">
    <el-form :model="search" :inline="true" label-position="right">
      <el-form-item prop="dateRange">
        <DateRangePicker :allowedDimensions="['day', 'month', 'year']" @update:search="handleDateRangeUpdate" />
      </el-form-item>
      <el-form-item label="旧机类型">
        <el-select v-model="search.oldMachineType" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="item in goodsTypeList" :key="item.value" :label="item.spmc" :value="item.spid" style="width: 100%"> </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="承运商" prop="carrierNo">
        <el-select v-model="search.carrierNo" placeholder="请选择" clearable style="width: 100%">
          <el-option v-for="item in carrierOption" :key="item.carrierNo" :label="item.carrierName" :value="item.carrierNo"> </el-option>
        </el-select>
      </el-form-item>
      <el-button type="primary" size="medium" @click="handleSearch">查询</el-button>
      <el-button size="medium" @click="handleExport" :loading="exportFlag">导出</el-button>
    </el-form>

    <div class="indicator-container">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>过程指标</span>
        </div>
        <div class="metric-grid">
          <MetricCard :value="orderCount" name="订单数量" :description="'用户下单总的数量'" />
          <MetricCard :value="completionCount" name="完工数量" :description="'回收完成的总数量'" />
          <MetricCard :value="completionRate" name="完工率" unit="%" :description="'回收完成的总数量/用户下单的总数量'" />
          <MetricCard :value="userCancelRate" name="用户取消率" unit="%" :description="'用户取消订单数量/用户下单的总数量'" />
          <MetricCard :value="engineerCancelRate" name="工程师取消率" unit="%" :description="'工程师取消订单数量/用户下单的总数量'" />
        </div>
      </el-card>

      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>结果指标</span>
        </div>
        <div class="metric-grid">
          <MetricCard :value="over3ResidualRate" name="超3遗留率" unit="%" :description="'(完工时间-订单创建时间>72小时的订单数量+当前时间-创建时间>72x小时的订单数量)/订单数量'" />
          <MetricCard :value="hours48CompletionRate" name="48小时完工率" unit="%" :description="'(完工时间-订单创建时间≤48小时的订单数量)/订单总数量'" />
          <MetricCard :value="hours72CompletionRate" name="72小时完工率" unit="%" :description="'(完工时间-订单创建时间≤72小时的订单数量)/订单总数量'" />
        </div>
      </el-card>
    </div>

    <div>
      <el-card class="box-card" style="margin-top: 20px;width: 100%;">
        <div slot="header" class="clearfix">
          <span>数据分析</span>
          <div style="float: right; padding: 3px 0">
            <el-dropdown :hide-on-click="false" placement="bottom-start" trigger="click">
              <el-button type="primary"> 切换维度<i class="el-icon-arrow-down el-icon--right"></i> </el-button>

              <el-dropdown-menu slot="dropdown" style="max-height: 300px; overflow-y: auto;">
                <el-checkbox-group v-model="search.dimensionCode" @change="handleDimensionChange" class="checkbox-item">
                  <el-checkbox v-for="item in oldMachineCompletedDimensionMap" :key="item.code" :label="item.code">
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-dropdown-menu>
            </el-dropdown>
            <el-dropdown :hide-on-click="false" placement="bottom-start" trigger="click">
              <el-button type="primary"> 切换指标<i class="el-icon-arrow-down el-icon--right"></i> </el-button>
              <el-dropdown-menu slot="dropdown">
                <el-checkbox-group v-model="search.orderInfo" @change="handleMetricChange" class="checkbox-item">
                  <el-checkbox v-for="item in exportField" :key="item.field" :label="item">
                    {{ item.chinese }}
                  </el-checkbox>
                </el-checkbox-group>
              </el-dropdown-menu>
            </el-dropdown>

          </div>
        </div>
        <div class="item-form">
          <el-table :data="list" center>
            <el-table-column label="时间_年" v-if="search.dimensionCode.includes('1')" min-width="150" prop="supplyYear" align="center" />
            <el-table-column label="时间_月" v-if="search.dimensionCode.includes('2')" min-width="150" prop="supplyMonth" align="center">
              <template slot-scope="{ row }"> {{ row.supplyYear }}_{{ row.supplyMonth }} </template>
            </el-table-column>
            <el-table-column label="时间_日" v-if="search.dimensionCode.includes('3')" min-width="150" prop="supplyDay" align="center">
              <template slot-scope="{ row }"> {{ row.supplyYear }}_{{ row.supplyMonth }}_{{ row.supplyDay }} </template>
            </el-table-column>
            <el-table-column label="区域_省" v-if="search.dimensionCode.includes('4')" min-width="150" prop="provinceName" align="center" />
            <el-table-column label="区域_市" v-if="search.dimensionCode.includes('5')" min-width="150" prop="cityName" align="center">
              <template slot-scope="{ row }"> {{ row.cityName }} </template>
            </el-table-column>
            <el-table-column label="承运商" v-if="search.dimensionCode.includes('6')" min-width="200" prop="carrierName" align="center" />
            <el-table-column prop="orderCount" label="订单数量" width="150" align="center" v-if="sortList.includes(1)"></el-table-column>
            <el-table-column prop="completedCount" label="完工数量" width="150" align="center" v-if="sortList.includes(2)"></el-table-column>
            <el-table-column prop="completedRate" label="完工率" align="center" width="150" v-if="sortList.includes(3)"></el-table-column>
            <el-table-column prop="userCancelRate" label="用户取消率" width="150" v-if="sortList.includes(4)" align="center"></el-table-column>
            <el-table-column prop="engineerCancelRate" label="工程师取消率" align="center" v-if="sortList.includes(5)"></el-table-column>
            <el-table-column prop="completedRateFirst" label="首约准时完工率" width="150" v-if="sortList.includes(6)" align="center"></el-table-column>
            <el-table-column prop="completedRateSecond" label="超3遗留率" align="center" width="150" v-if="sortList.includes(7)"></el-table-column>
            <el-table-column prop="completedRateThird" label="48小时完工率" align="center" width="150" v-if="sortList.includes(8)"></el-table-column>
            <el-table-column prop="completedRateFourth" label="72小时完工率" align="center" width="150" v-if="sortList.includes(9)"></el-table-column>
          </el-table>
          <div class="pagination-container">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes,prev, pager, next,jumper"
              :current-page.sync="pageNum"
              :page-size="pageSize"
              :page-sizes="[10, 20]"
              :total="total"
            >
            </el-pagination>
          </div>
        </div>
      </el-card>
    </div>
  </div>
</template>

<script>
import DateRangePicker from '../components/DateRangePicker.vue'
import MetricCard from '../components/MetricCard.vue'
import { getPartner, getUserOrderRate, pageUserOrderRate, getNomalExportField, getNormalOrderMetricsDimensionMap } from '@/api/oldForNew'

export default {
  components: {
    DateRangePicker,
    MetricCard
  },
  data() {
    return {
      search: {
        supplyDay: undefined, // 日
        supplyMonth: undefined, // 月份
        supplyYear: undefined, // 年份
        cityLevel: undefined, // 城市等级
        carrierNo: undefined, // 承运商No
        dimensionCode: [], //维度code
        orderInfo: [], // 订单信息
        oldMachineType: undefined //旧机类型
      },
      pageNum: 1,
      pageSize: 10,
      carrierOption: [], // 承运商选项列表
      total: 0,
      list: [],
      cityLevelList: [],
      exportField: [], //导出字段枚举值
      oldMachineCompletedDimensionMap: [], //维度枚举值
      avgCompletedDuration: undefined, //完成平均时长
      exportFlag: false,
      dynamicColumns: [], // 动态生成的表格列
      orderCount: 0, // 订单数量
      completionCount: 0, // 完工数量
      completionRate: 0, // 完成率
      userCancelRate: 0, // 用户取消率
      engineerCancelRate: 0, // 工程师取消率
      over3ResidualRate: 0, // 超3遗留率
      hours48CompletionRate: 0, // 48小时完工率
      hours72CompletionRate: 0, // 72小时完工率
      goodsTypeList: [], //旧机类型
      exportFlag: false,
      sortList: [1, 2, 3, 4, 5, 6, 7, 8, 9]
    }
  },
  methods: {
    handleDateRangeUpdate(data) {
      if (data.supplyYear) {
        this.search.supplyYear = data.supplyYear
        this.search.supplyMonth = data.supplyMonth
        this.search.supplyDay = data.supplyDay
      } else {
        this.search.supplyYear = undefined
        this.search.supplyMonth = undefined
        this.search.supplyDay = undefined
      }
      if (data.supplyDay) {
        this.search.supplyDay = data.supplyDay
        this.search.supplyYear = undefined
        this.search.supplyMonth = undefined
      }
    },

    prepareSearchParams(search) {
      // 深拷贝 search 对象以避免修改原始对象
      let params = JSON.parse(JSON.stringify(search))

      // 删除 supplyDay 属性
      delete params.supplyDay

      // 设置年份和月份
      params.supplyYear = search.supplyYear ? Number(search.supplyYear) : ''
      params.supplyMonth = search.supplyMonth ? Number(search.supplyMonth) : ''

      // 处理日期范围
      if (search.supplyDay && search.supplyDay.length === 2) {
        params.startDate = search.supplyDay[0]
        params.endDate = search.supplyDay[1]
      } else {
        params.startDate = ''
        params.endDate = ''
      }

      return params
    },
    handleSearch() {
      // 重置页码为第一页
      this.pageNum = 1

      // 获取所有指标（统一接口）
      this.fetchAllMetrics()

      // 获取分页列表数据
      this.fetchPageList()
    },
    handleSizeChange(val) {
      this.pageNum = 1
      this.pageSize = val
      this.fetchPageList() // 调用 fetchPageList 重新加载数据
    },
    handleCurrentChange(page) {
      this.pageNum = page
      this.fetchPageList() // 调用 fetchPageList 重新加载数据
    },

    //获取承运商
    async getPartnerList() {
      let { statusCode, data } = await getPartner()
      if (statusCode == 200) {
        this.carrierOption = data
      }
    },

    // 获取分页列表数据
    async fetchPageList() {
      const params = this.prepareSearchParams(this.search)

      try {
        const res = await pageUserOrderRate(this.global.clearEmptyParam(params))
        if (res.statusCode === 200 && res.data) {
          // 前端分页处理
          const allData = res.data || []
          this.total = allData.length // 总数据量为数组长度

          // 实现前端分页
          const start = (this.pageNum - 1) * this.pageSize
          const end = start + this.pageSize
          this.list = allData.slice(start, end)
        }
      } catch (error) {
        console.error('获取分页列表失败:', error)
        this.$message.error('获取分页列表失败')
      }
    },

    //获取维度枚举值
    async getNormalOrderMetricsDimensionMap() {
      try {
        const res = await getNormalOrderMetricsDimensionMap()
        if (res.statusCode === 200) {
          // 数据格式转换：将 Map<String, String> 转换为 {code, name} 格式
          this.oldMachineCompletedDimensionMap = res.data.map(item => {
            const [key, value] = Object.entries(item)[0]
            return {
              code: key,
              name: value
            }
          })
        }
      } catch (error) {
        console.error('获取维度枚举值失败:', error)
      }
    },
    //获取导出字段枚举值
    async getNomalExportField() {
      try {
        const res = await getNomalExportField()
        if (res.statusCode === 200 && res.data) {
          this.exportField = res.data
          this.search.orderInfo = res.data
          this.sortList = res.data.map(item => item.sort)
          console.log('----getNomalExportField----', res.data, this.sortList)
          this.handleMetricChange()
        }
      } catch (error) {
        console.error('获取导出字段枚举值失败:', error)
      }
    },

    // 获取所有指标（统一接口）
    async fetchAllMetrics() {
      const params = this.prepareSearchParams(this.search)
      try {
        const res = await getUserOrderRate(this.global.clearEmptyParam(params))
        console.log('----fetchAllMetrics----', res.data)
        if (res.statusCode === 200 && res.data) {
          // 过程指标
          this.orderCount = res.data.orderCount || 0
          this.completionCount = res.data.completedCount || 0
          this.completionRate = res.data.completedRate || 0
          this.userCancelRate = res.data.userCancelRate || 0
          this.engineerCancelRate = res.data.engineerCancelRate || 0

          // 结果指标
          this.over3ResidualRate = res.data.completedRateSecond || 0
          this.hours48CompletionRate = res.data.completedRateThird || 0
          this.hours72CompletionRate = res.data.completedRateFourth || 0
        }
      } catch (error) {
        console.error('获取指标失败:', error)
      }
    },

    getTblSplbDalei() {
      let parmas = {
        flag: 1
      }
      return this.HttpService.get('/autoapp-default-server-recovery/api/tbl-splb-dalei/getTblSplbDalei', parmas).then(res => {
        if (res.statusCode === 200) {
          this.goodsTypeList = res.data
        }
      })
    },

    handleExport() {
      this.exportFlag = true
      const params = this.prepareSearchParams(this.search)
      params.orderInfo = this.search.orderInfo.map(item => ({
        ...item,
        select: 1
      }))

      const url = `/autoapp-default-server-recovery/api/dataBorad/userOrderRate/exprot/pageUserOrderRate`
      this.HttpService.post(url, this.global.clearEmptyParam(params)).then(res => {
        if (res.statusCode == 200) {
          this.$message.success('正在导出, 稍后请到下载中心查看')
          this.exportFlag = false
        } else {
          this.$message.warning(res.message)
        }
      })
    },
    //维度多选框
    handleDimensionChange(selectedCodes) {
      // 更新 search.dimensionCode 并排序
      this.search.dimensionCode = selectedCodes.sort((a, b) => parseInt(a) - parseInt(b))
      this.handleSearch()
    },
    handleMetricChange(selectedMetrics) {
      if (!selectedMetrics) {
        return
      }
      // 更新 search.orderInfo 并排序
      this.search.orderInfo = selectedMetrics.sort((a, b) => a.field.localeCompare(b.field))
      this.sortList = selectedMetrics.map(item => item.sort)
      this.handleSearch()
    }
  },
  mounted() {
    this.search.dimensionCode = ['1', '2', '3', '4', '5', '6'] //默认全选
    this.getPartnerList()
    this.getNomalExportField()
    this.getNormalOrderMetricsDimensionMap()
    this.handleSearch()
    this.getTblSplbDalei()
  }
}
</script>

<style lang="scss" scoped>
.indicator-container {
  display: flex;
  gap: 16px;
  margin-bottom: 16px;
}

.metric-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 16px;
}

.box-card {
  flex: 1;
  min-width: 0;

  /deep/ .el-card__header {
    padding: 12px 20px;
    background-color: #f5f7fa;
    border-bottom: 1px solid #e8e8e8;
  }

  /deep/ .el-card__body {
    padding: 16px;
  }
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: '';
}
.clearfix:after {
  clear: both;
}

.box-card {
  flex: 1;
}
.row {
  margin-bottom: 15px;
}
.item-form {
  width: 100%;
}
.checkbox-item {
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 8px;
}
</style>



// WEBPACK FOOTER //
// src/views/dataBoard/performanceMonitoring/normalOrder.vue